import React from 'react'

function Gallary() {
  return (
    <div>Gallary</div>
  )
}

export default Gallary